import React, { useState, useEffect } from 'react';
import { useAuth } from '../hooks/useAuth';
import { API_BASE_URL } from '../config';

const LoginPage = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const { login } = useAuth();

  // Effetto per l'animazione di entrata
  useEffect(() => {
    // Piccolo ritardo per assicurarsi che il componente sia montato
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 150);
    
    return () => clearTimeout(timer);
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    try {
      const response = await fetch(`${API_BASE_URL}/auth/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username, password }),
      });

      const data = await response.json();
      
      if (response.ok) {
        // Use the login method from useAuth
        login(data.user, data.access_token);
        
        // Redirect based on role
        switch(data.user.role) {
          case 'admin':
            window.location.href = '/';
            break;
          case 'supervisor':
            window.location.href = '/';
            break;
          case 'agent':
          default:
            window.location.href = '/';
        }
      } else {
        // Handle login errors
        setError(data.detail || 'Login fehlgeschlagen');
      }
    } catch (err) {
      setError('Verbindungsfehler. Bitte versuchen Sie es später erneut.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col justify-start md:justify-center bg-gradient-to-br from-indigo-50 to-blue-100 py-4 px-4 sm:px-6 lg:px-8">
      <div 
        className={`max-w-md w-full mx-auto mt-8 mb-4 bg-white rounded-xl shadow-2xl overflow-hidden transition-all duration-1400 transform ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}
      >
        <div className="bg-gradient-to-r from-indigo-600 to-indigo-800 shadow-md py-6 px-4">
          <div className="flex flex-col items-center text-center">
            {/* Logo Favicon - B Cerchiata */}
            <div className="mb-4">
              <div className="w-20 h-20 rounded-full bg-indigo-600 flex items-center justify-center shadow-lg transform transition-transform duration-300 hover:scale-105">
                <span className="text-4xl font-bold text-white">B</span>
              </div>
            </div>
            
            {/* Logo Testuale */}
            <div>
              <div className="flex items-center justify-center">
                <span className="text-3xl font-bold text-white tracking-wide">BONOBO</span>
                <span className="ml-3 text-lg text-white text-opacity-75 font-medium">CRM</span>
              </div>
              <div className="text-sm text-white text-opacity-70 mt-1">Customer Relations Management</div>
            </div>
          </div>
        </div>
        
        <div className="px-6 py-5">
          <form 
            className="space-y-4" 
            onSubmit={handleLogin}
            noValidate
          >
            <div className="space-y-3">
              <div>
                <label htmlFor="username" className="block text-sm font-medium text-gray-700 mb-1">Benutzername</label>
                <input
                  id="username"
                  name="username"
                  type="text"
                  autoComplete="username"
                  required
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  className="appearance-none relative block w-full px-3 py-2 border border-gray-300 rounded-md text-gray-900 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors duration-200 ease-in-out sm:text-sm"
                />
              </div>
              <div>
                <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1">Passwort</label>
                <input
                  id="password"
                  name="password"
                  type="password"
                  autoComplete="current-password"
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="appearance-none relative block w-full px-3 py-2 border border-gray-300 rounded-md text-gray-900 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors duration-200 ease-in-out sm:text-sm"
                />
              </div>
            </div>

            {error && (
              <div className="text-center bg-red-50 p-2 rounded-md">
                <p className="text-red-600 text-sm">{error}</p>
              </div>
            )}

            <div>
              <button
                type="submit"
                disabled={isLoading}
                className={`group relative w-full flex justify-center py-2.5 px-4 border border-transparent text-sm font-medium rounded-md text-white transition-all duration-200 ease-in-out
                  ${isLoading 
                    ? 'bg-gray-500 cursor-not-allowed' 
                    : 'bg-gradient-to-r from-indigo-600 to-indigo-700 hover:from-indigo-700 hover:to-indigo-800 shadow-md hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500'
                  }`}
              >
                {isLoading ? (
                  <span className="flex items-center">
                    <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    Anmeldung...
                  </span>
                ) : 'Anmelden'}
              </button>
            </div>
          </form>
          
        </div>
      </div>
    </div>
  );
};

export default LoginPage;